.group {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
  margin: 0;
  padding: 0;
  border: none;
}

.toggle {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  min-height: 2rem;
  font-size: var(--font-size-sm);
  cursor: pointer;
}

@media (pointer: coarse) {
  .toggle {
    min-height: var(--touch-target);
  }
}
